export const metricType = {
  METRIC: 'metric',
  SUBMETRIC: 'submetric'
}

export const badgeType = {
  success: 'success',
  danger: 'danger',
  warning: 'warning',
  filled: 'filled'
}
